import { render, staticRenderFns } from "./FeatureFlagsPage.vue?vue&type=template&id=5c9a4a9e&"
import script from "./FeatureFlagsPage.vue?vue&type=script&lang=js&"
export * from "./FeatureFlagsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports